<style lang="scss">

</style>

<template>
    <section class="ui-stats-item">
      <div class="col-12">

        <div>
          <section  v-if="!loadingStats">
            <h4 class="text-center title-divider top-divider font-weight-bold">
              Age breakdown of verified {{additionalUser ? 'additional' : ''}}
              callers with contact in {{$options.filters.term('prison', true)}}
            </h4>

            <p class="text-right brand-color font-weight-bold my-2">
              Total {{additionalUser ? 'additional' : ''}} Callers: {{stats.total}}
            </p>

            <div class="apex-pie-wrapper">
              <pie-chart-simple v-if="stats.total > 0"
                                max-width="600px" chart-id="chartVisitor" :series="chartSimple"></pie-chart-simple>
              <p v-else>
                No data for {{additionalUser ? 'additional' : ''}} Callers
              </p>
            </div>

          </section>

          <section v-else class="d-flex justify-content-center pb-4 pt-5 flex-wrap">
            <p class="full-width d-flex justify-content-center">Getting Stats...</p>
            <b-spinner variant="primary"></b-spinner>
          </section>
        </div>
      </div>
    </section>
</template>

<script>
  import Vue from 'vue';
  import VisitorUsersService from '../../../services/VisitorService';
  import HelperService from '../../../services/HelperService';
  import ChartService from '../../../services/ChartService';
  import PieChartSimple from '../../../components/charts/PieChartSimple';

  export default {
    props: {
      filters: {
        required: true,
        type: Object,
      },
      additionalUser: {
        required: false,
        type: Boolean,
      },
    },
    components: {
      PieChartSimple,
    },
    watch: {
      filters: {
        handler() {
          this.getStats();
        },
        deep: true,
      },
    },
    data() {
      return {
        helperService: new HelperService(),
        loadingStats: true,
        stats: [],
        chartSimple: null,
        chart: {
          series: {
            name: 'Cancellation Reason',
            data: [],
          },
          options: {
            colors: [],
            labels: [],
          },
        },
      };
    },
    mounted() {
      this.chart.options.colors = ChartService.getChartColors();
      this.getStats();
    },
    methods: {
      getStats() {
        if (this.additionalUser) {
          this.getAdditionalVisitorUsersStats();
        } else {
          this.getVisitorUsersStats();
        }
      },
      getVisitorUsersStats() {
        this.loadingStats = true;

        if (this.filters.prisonId || this.filters.prisonGroupId) {
          return VisitorUsersService.getVisitorUserAgeDistStats(this.filters).then((res) => {
            this.stats = res.data;
            this.chartSimple = this.createChartJsChart(this.stats);
          }).catch((err) => {
            console.log('could not get visitor users stats', err);
            this.$toasted.error('Network timed out please try a shorter time range');
          }).finally(() => {
            setTimeout(() => {
              this.loadingStats = false;
            }, 1000);
          });
        }

        return null;
      },
      getAdditionalVisitorUsersStats() {
        this.loadingStats = true;

        if (this.filters.prisonId || this.filters.prisonGroupId) {
          // eslint-disable-next-line max-len
          return VisitorUsersService.getAdditionalVisitorUserAgeDistStats(this.filters).then((res) => {
            this.stats = res.data;
            this.chartSimple = this.createChartJsChart(this.stats);
          }).catch((err) => {
            console.log('could not get visitor users stats', err);
            this.$toasted.error('Network timed out please try a shorter time range');
          }).finally(() => {
            setTimeout(() => {
              this.loadingStats = false;
            }, 1000);
          });
        }

        return null;
      },
      createChartJsChart(ageData) {
        let ageDataNew = JSON.parse(JSON.stringify(ageData)); // deep clone
        let chart = {
          data: [],
          labels: [],
        };

        if(!this.additionalUser) {
          Vue.delete(ageDataNew.ages, 'under_18'); // delete if not additional
        }

        for (const [key, value] of Object.entries(ageDataNew.ages)) {
          chart.data.push(value);
          chart.labels.push(this.formatAgeLabel(key));
        }

        return chart;
      },
      formatAgeLabel(text) {
        return text.replace(/_/g, ' ');
      },
    },
  };
</script>
